import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Form } from "react-bootstrap";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import config from "../../Config";
import SetupMenu from "./SetupMenu";

function AddStudentHouse() {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));
  const [validated, setValidated] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const navigate = useNavigate();

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }

    setLoading(true);
    axios({
      method: "post",
      url: config.base_url + "StudentHouse/SaveStudentHouse",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey,
        UserID,
        MemberType,
        ID: 0,
        HouseName: event.target.houseName.value.trim(),
        Is_Active: isActive,
      },
    })
      .then((response) => {
        if (response.data.status_code === 1) {
          toast.success(response.data.status_message);
          navigate("/Setup/ManageStudentHouses");
        } else {
          toast.error(response.data.status_message || "Save failed.");
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        toast.error("Network error.");
      });

    setValidated(true);
  };

  return (
    <>
      <SetupMenu />
      <ToastContainer />
      <div className="page-head">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/Dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/Setup/SetupDashboard">Setup</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Add Student House
                  </li>
                </ol>
              </nav>
              <div className="page-title">Add Student House</div>
            </div>
            <div className="col-md-6">
              <div className="page-right-actions">
                <Link
                  to="/Setup/ManageStudentHouses"
                  className="button button-white button-icon"
                >
                  Manage Student Houses
                  <i className="ri-list-check"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="page-content">
        <div className="container">
          <div className="card">
            <div className="card-body p-md-4">
              <Form noValidate validated={validated} onSubmit={handleSubmit}>
                <div className="row gy-3" style={{ maxWidth: "520px" }}>
                  <div className="col-12">
                    <label className="form-label">House Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="houseName"
                      maxLength={200}
                      required
                    />
                  </div>
                  <div className="col-12">
                    <Form.Check
                      type="checkbox"
                      id="studentHouseActive"
                      label="Active"
                      checked={isActive}
                      onChange={(e) => setIsActive(e.target.checked)}
                    />
                  </div>
                  <div className="col-12">
                    {loading ? (
                      <Spinner animation="border" role="status" />
                    ) : (
                      <button type="submit" className="button button-primary">
                        Save
                      </button>
                    )}
                    <Link
                      to="/Setup/ManageStudentHouses"
                      className="button button-outline-primary ms-2"
                    >
                      Cancel
                    </Link>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddStudentHouse;
